'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import PropTypes from 'prop-types';
import { useCallback, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { SORT_FIELD_ORDER } from '../../constants/search';
import * as FilterKey from '../../constants/search/FilterKey';
import * as SortField from '../../constants/search/SortField';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { updateStorefrontFilters } from '../../slices/storefrontFiltersSlice';
import { getHasFilters } from '../../utils/filters';
import { getTranslatedSortText } from '../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const textPath = 'ecosystem-marketplace-solutions-ui.storefront.results.sort';
const ValueComponent = ({
  children
}) => /*#__PURE__*/_jsx("span", {
  role: "button",
  children: children
});
const SortDropdown = ({
  filters
}) => {
  const dispatch = useDispatch();
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const sortOptions = useMemo(() => {
    const hasFilters = getHasFilters(filters);
    return SORT_FIELD_ORDER.filter(sort => sort !== SortField.RELEVANCE_DESC || hasFilters).map(sort => {
      return {
        text: getTranslatedSortText(sort),
        value: sort
      };
    });
  }, [filters]);
  const handleSortChange = useCallback(evt => {
    const sort = evt.target.value;
    dispatch(updateStorefrontFilters({
      updates: {
        [FilterKey.SORTS]: sort
      }
    }));
    trackInteraction('change sort', {
      sortField: sort
    });
  }, [dispatch, trackInteraction]);
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${textPath}.label`
    }),
    marginInlineEnd: "0",
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "storefront-sort-dropdown",
      buttonUse: "transparent",
      menuWidth: "auto",
      onChange: handleSortChange,
      options: sortOptions,
      placement: "bottom left",
      value: filters[FilterKey.SORTS],
      valueComponent: ValueComponent
    })
  });
};
SortDropdown.propTypes = {
  filters: PropTypes.object.isRequired
};
export default SortDropdown;